export interface AdSummary {
  id: string
  sequentialId: number
  serviceOfferId: number
  serviceOfferName: string
}

export interface Period {
  startsAt: string
  endsAt: string
}

export interface Price {
  currency: string
  originalAmount: number
  discountedAmount: number
  discountRatio: number
}

export interface Rating {
  totalRating: number
  ratingCount: number
}

export enum AdExposureAvailability {
  AVAILABLE = 'AVAILABLE',
  PAUSED = 'PAUSED',
  BLOCKED = 'BLOCKED',
}

export interface Ad {
  id: string
  adGroupId: string
  status: AdExposureAvailability
  serviceOfferId: number
}
